import { render } from "./Candle.vue?vue&type=template&id=fb4769dc&scoped=true&lang=html"
import script from "./Candle.vue?vue&type=script&lang=js"
export * from "./Candle.vue?vue&type=script&lang=js"

import "./Candle.vue?vue&type=style&index=0&id=fb4769dc&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4769dc"]])

export default __exports__